import React from 'react';
import Spacing from '../Spacing';
import SectionHeadingStyle3 from '../SectionHeading/SectionHeadingStyle3';
import { Icon } from '@iconify/react';
import AuthorWidget from '../Widget/AuthorWidget';
import { pageTitle } from '../../helpers/PageTitle';

export default function BlogDetailsPage() {
  pageTitle('Blog Details');
  return (
    <>
      <Spacing lg="70" md="70" />
      <Spacing lg="140" md="80" />
      <SectionHeadingStyle3
        title="Stay Updated with the Latest in Renewable Energy"
        variant="text-center"
        shape="shape_5"
        category="Renewable Energy"
        date="07 Mar 2022"
        avatar="Sustainability"
        avatarLink="/"
      />
      <Spacing lg="75" md="60" />
      <div className="container">
        <img
          src="/images/blog/post_details_1.jpeg"
          alt="Blog"
          className="cs_radius_15"
        />
        <div className="cs_height_60 cs_height_lg_40" />
        <div className="cs_post_details">
          <h3>
            Dive deep into the world of renewable energy with our insightful blog, offering expert advice on solar technology, wind energy solutions, and sustainable living. Learn how to harness the power of nature efficiently and cost-effectively, with a focus on innovation and sustainability.
          </h3>
          <p>
            The journey to a sustainable future is fraught with challenges, but also rich with opportunities. Through technological advances and informed consumer choices, we can significantly impact our environmental footprint. Each blog post aims to enlighten and inspire action towards a greener tomorrow.
          </p>
          <p>
            Embrace the complexities of transitioning to renewable energy with guides on solar panel installation, wind turbine efficiency, and the economics of renewable investments. Our blog serves as a vital resource for anyone looking to make informed decisions about their energy consumption and production.
          </p>
          <div className="cs_height_10 cs_height_lg_5" />
          <div className="row">
            <div className="col-md-4">
              <img
                src="/images/blog/post_details_2.jpeg"
                alt="Thumb"
                className="w-100"
              />
            </div>
            <div className="col-md-4">
              <img
                src="/images/blog/post_details_3.jpeg"
                alt="Thumb"
                className="w-100"
              />
            </div>
            <div className="col-md-4">
              <img
                src="/images/blog/post_details_4.jpeg"
                alt="Thumb"
                className="w-100"
              />
            </div>
          </div>
          <div className="cs_height_10 cs_height_lg_5" />
          <h3>The Impact of Renewable Energy on Global Sustainability</h3>
          <p>
            Renewable energy not only offers an escape from the conventional energy grid but also a pathway to a less polluted world. This section explores the broader implications of adopting renewable sources on global health, economic stability, and geopolitical landscapes.
          </p>
          <blockquote>
            “Understanding the interconnectedness of our actions and environmental impact is the first step towards adopting sustainable practices that benefit both the planet and future generations.”
            <small>Dr. Sarah Johnson, Environmental Scientist</small>
          </blockquote>
          <p>
            Our commitment to promoting renewable energy extends beyond simple advocacy. By providing actionable insights and data-driven analysis, we aim to empower individuals and communities to participate actively in the global transition to sustainable energy sources.
          </p>
          <ul>
            <li>Exploring innovative renewable energy technologies</li>
            <li>Guidelines for sustainable energy consumption</li>
            <li>Strategies for effective energy production and storage</li>
          </ul>
        </div>
        <div className="cs_height_30 cs_height_lg_10" />
        <div className="cs_post_share">
          <div className="cs_categories">
            <a href="/" className="cs_category">
              Solar Energy
            </a>
            <a href="/" className="cs_category">
              Wind Power
            </a>
          </div>
          <div className="text-center">
            <div className="cs_post_share_btns">
              <a href="/">
                <Icon icon="fa6-brands:twitter" />
              </a>
              <a href="/">
                <Icon icon="fa6-brands:facebook-f" />
              </a>
              <a href="/">
                <Icon icon="fa6-brands:linkedin-in" />
              </a>
            </div>
            <span className="cs_post_share_title">Share this Article</span>
          </div>
        </div>
        <div className="cs_height_50 cs_height_lg_40" />
        <AuthorWidget />
        <div className="cs_height_88 cs_height_lg 60" />
        <h2 className="text-center cs_fs_50 mb-0">Leave A Comment</h2>
        <div className="cs_height_60 cs_height_lg 30" />
        <form action="#" className="row">
          <div className="col-lg-6">
            <input
              type="text"
              className="cs_form_field_2"
              placeholder="Your Name"
            />
            <div className="cs_height_50 cs_height_lg 30" />
          </div>
          <div className="col-lg-6">
            <input
              type="text"
              className="cs_form_field_2"
              placeholder="Your Email"
            />
            <div className="cs_height 50 cs_height_lg 30" />
          </div>
          <div className="col-lg-12">
            <textarea
              cols={30}
              rows={7}
              className="cs_form_field_2"
              placeholder="Share your thoughts on renewable energy"
            />
            <div className="cs_height 60 cs_height_lg 30" />
          </div>
          <div className="col-lg-12 text-center">
            <button className="cs_btn cs_style_1">
              Submit Comment{' '}
              <span>
                <i className="fa-solid fa-arrow-right" />
              </span>
            </button>
          </div>
        </form>
        <div className="cs_height_150 cs_height_lg 80" />
      </div>
    </>
  );
}
